import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import styles from './Breadcrumbs.styles.scss';
import cn from 'classnames';

const HeaderBreadcrumbIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0053 5.00632C10.1713 4.84034 10.4404 4.84034 10.6064 5.00632L13.2987 7.69861C13.4646 7.86454 13.4647 8.13355 13.2988 8.29954L10.6075 10.9928C10.4415 11.1588 10.1724 11.1589 10.0064 10.993C9.84038 10.8271 9.84028 10.558 10.0062 10.392L11.9723 8.42451L3.00011 8.42783C2.76539 8.42792 2.57504 8.23771 2.57495 8.00299C2.57486 7.76827 2.76507 7.57792 2.99979 7.57783L11.9725 7.57451L10.0053 5.60736C9.83937 5.44138 9.83937 5.17229 10.0053 5.00632Z"
      fill="#707070"
    />
  </svg>
);

const Breadcrumbs = ({
  routeNames,
  onHomeClick,
  onRouteClick,
  isTaxReturn,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.breadcrumbs}>
      <div className={styles.route}>
        {routeNames?.map((route) => (
          <React.Fragment key={route.link}>
            <Button
              link
              className={cn(styles.routeText, route.link ? styles.pointer : '')}
              onClick={() => onRouteClick(route.link)}
            >
              {t(route.label)}
            </Button>
            <span className={cn(styles.separatorIcon, 'mx-2')}>
              <HeaderBreadcrumbIcon />
            </span>
          </React.Fragment>
        ))}
        <Button link onClick={onHomeClick} className={cn(styles.homeRouteText)}>
          {isTaxReturn ? 'Taxpayer Portal' : t('common.web_portal')}
        </Button>
      </div>
    </div>
  );
};

export default React.memo(Breadcrumbs);
